import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';

import Maintance from '../../pages/MaintancePage/MaintancePage';
import { login } from '../../Requests/login/login';
import { useBalanceStore } from '../../store/BalanceStore';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  isLoading: true,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const navigate = useNavigate();
  const setBalance = useBalanceStore((state) => state.setBalance);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await login();
        console.log(response, 'fasfasfsa');
        if (response) {
          setIsAuthenticated(true);
          setBalance(response.wallet.beastcoins);
        }
      } catch (error) {
        console.error('Authentication failed:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return null; // Убираем кружок, показываем только Loader с LottieAnimation на MainPage
  }

  if (!isAuthenticated) {
    return <Maintance />;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
